import { useQuery } from "@tanstack/react-query";
import {
  listProducts,
  getProductDetail,
  getProductRelated,
  getAddons,
} from "./api";

export const useProducts = (params) =>
  useQuery({
    queryKey: ["products", params],
    queryFn: () => listProducts(params),
    keepPreviousData: true,
    staleTime: 60_000,
  });

export const useLowestPrice = (mounting) =>
  useQuery({
    queryKey: ["lowest-price", mounting ?? "all"],
    queryFn: async () => {
      const params = mounting ? { kind: "vanity", mounting } : { kind: "vanity" };
      const res = await listProducts(params);
      return res.items.reduce((min, it) => (it.price < min ? it.price : min), Infinity);
    },
    staleTime: 120_000,
  });

export const useProductDetail = (id) =>
  useQuery({
    queryKey: ["product", id],
    queryFn: () => getProductDetail(id),
    enabled: Boolean(id),
    retry: false,
  });

export const useRelated = (id, limit = 4) =>
  useQuery({
    queryKey: ["related", id, limit],
    queryFn: () => getProductRelated(id, limit),
    enabled: Boolean(id),
  });

export const useAddons = (productId) =>
  useQuery({
    queryKey: ["addons", productId],
    queryFn: () => getAddons(productId),
    enabled: Boolean(productId),
  });